/* POSHRADS — quantity-input.js
   Progressive enhancement for quantity fields (cart, product): "−/+" step the linked input.
   Values are still submitted by the native form (no Ajax).
   One delegated listener, registered once. */
(() => {
  'use strict';

  if (window.poshQuantityReady) return;
  window.poshQuantityReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input) return;
    if (Number(button.dataset.quantityStep) > 0) input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
